import { Outlet } from 'react-router-dom';
import { UtensilsCrossed } from 'lucide-react';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rango-50 via-white to-rango-100">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-rango-200/50 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-rango-300/30 blur-3xl" />
      </div>
      
      <div className="relative flex min-h-screen flex-col">
        {/* Header */}
        <header className="flex items-center justify-center py-8">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-rango-500 text-white shadow-lg shadow-rango-500/30">
              <UtensilsCrossed className="h-7 w-7" />
            </div>
            <span className="font-display text-3xl font-bold text-rango-900">Rango</span>
          </div>
        </header>
        
        {/* Content */}
        <main className="flex flex-1 items-center justify-center px-4 pb-8">
          <Outlet />
        </main>
        
        {/* Footer */}
        <footer className="py-4 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Rango. Todos os direitos reservados.</p>
        </footer>
      </div>
    </div>
  );
}

